module.exports = __webpack_public_path__ + "static/media/logo_white@3x.1f4f1a76.png";